import styled from "styled-components";
import { Grid as SemanticGrid, GridColumn, Input } from "semantic-ui-react";
import MaterialPagination from "@material-ui/lab/Pagination";
import { AiFillCloseCircle, AiOutlineSearch } from "react-icons/ai";

export const SearchContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const SearchInput = styled(Input)`
  width: 100%;
  margin-right: 10px;
`;

export const Pagination = styled(MaterialPagination)`
  margin-left: auto;
  margin-right: auto;
  width: max-content;
`;

export const Grid = styled(SemanticGrid)`
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

export const Column = styled(GridColumn)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-left: 0 !important;
  padding-right: 0 !important;
`;

export const SearchIcon = styled(AiOutlineSearch)`
  cursor: pointer;
`;

export const CleanSearchIcon = styled(AiFillCloseCircle)`
  cursor: pointer;
`;
